// CtaReportsPanel — CTA arbóreo specific reports
import { ctaReports } from "@/mocks/relatorios";

const typeIcons: Record<string, string> = {
  "Inventário arbóreo": "ri-tree-line",
  "Técnico": "ri-file-list-3-line",
  "FCA individual": "ri-file-text-line",
  "Espécies": "ri-leaf-line",
  "Árvores de risco": "ri-alert-line",
  "Manejo recomendado": "ri-scissors-line",
  "Auditoria": "ri-search-line",
};

export default function CtaReportsPanel() {
  return (
    <div className="space-y-4">
      <h3 className="text-sm font-semibold text-foreground-900">Relatórios CTA Arbóreo</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {ctaReports.map((r) => (
          <div key={r.id} className="bg-white rounded-xl border border-background-200/70 p-4 hover:border-primary-200 transition-colors group">
            <div className="flex items-start gap-3 mb-3">
              <div className="w-10 h-10 rounded-xl bg-primary-50 flex items-center justify-center shrink-0">
                <i className={`${typeIcons[r.type] || "ri-file-line"} text-primary-500 w-full h-full flex items-center justify-center text-lg`} />
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="font-semibold text-foreground-900 text-sm">{r.title}</h4>
                <p className="text-xs text-foreground-400 mt-1 line-clamp-2">{r.description}</p>
              </div>
            </div>
            <div className="flex flex-wrap gap-1.5 mb-3">
              {r.indicators.map((ind, i) => (
                <span key={i} className="text-xs bg-background-50 text-foreground-500 px-2 py-0.5 rounded border border-background-200">{ind}</span>
              ))}
            </div>
            <div className="flex items-center justify-between">
              <span className="text-xs text-foreground-400">Última geração: {r.lastGenerated}</span>
              <button className="px-3 py-1.5 text-xs font-medium text-white bg-primary-500 rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap opacity-0 group-hover:opacity-100">
                <i className="ri-magic-line w-3.5 h-3.5 inline-flex items-center justify-center mr-1" />
                Gerar
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}